/**
 * Split a string into an array of selectors using a separator.
 */
export const split = (str: string, separator: string = ';'): string[] => str.split(separator);
